import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { APP_PATHS, PAGE_PATHS, Permission } from '../../../../../../types';

const path = PAGE_PATHS.FINDINGS;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.Finding,
  },
  validateSearch: zodValidator(withDefaults(schema.FINDINGS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path, app: APP_PATHS.VULNERABILITIES, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
